import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "mx-auto w-full max-w-sm lg:w-96" }
const _hoisted_2 = { class: "mt-8 text-2xl/9 font-bold tracking-tight text-gray-900" }
const _hoisted_3 = { class: "mt-2 text-sm/6 text-gray-500" }
const _hoisted_4 = { class: "mt-10" }
const _hoisted_5 = {
  for: "email",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_6 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "email-error"
}
const _hoisted_8 = { class: "flex justify-between items-center" }
const _hoisted_9 = {
  for: "password",
  class: "block text-sm/6 font-medium text-gray-900"
}
const _hoisted_10 = { class: "text-sm/6" }
const _hoisted_11 = { class: "mt-2 grid grid-cols-1" }
const _hoisted_12 = {
  key: 0,
  class: "mt-2 text-sm text-red-600",
  id: "password-error"
}
const _hoisted_13 = {
  type: "submit",
  class: "flex w-full justify-center rounded-md bg-royal-blue-500 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-royal-blue-600 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royal-blue-500 cursor-pointer"
}
const _hoisted_14 = { class: "mt-8" }
const _hoisted_15 = { class: "relative" }
const _hoisted_16 = { class: "relative flex justify-center text-sm/6 font-medium" }
const _hoisted_17 = { class: "bg-white px-6 text-gray-900" }
const _hoisted_18 = { class: "mt-6 grid grid-cols-1 gap-4" }
const _hoisted_19 = { class: "text-sm/6 font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[4] || (_cache[4] = _createElementVNode("img", {
        class: "h-10 w-auto",
        src: _imports_0,
        alt: "Gallera"
      }, null, -1)),
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.$t('auth_login.title')), 1),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('auth_login.not_registered')) + " ", 1),
        _createVNode(_component_router_link, {
          to: "/register",
          class: "font-semibold text-royal-blue-600 hover:text-royal-blue-500"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('auth_login.try_free')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("form", {
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.store && _ctx.store(...args)), ["prevent"])),
          class: "space-y-6"
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('auth_login.email')), 1),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                id: "email",
                type: "email",
                class: _normalizeClass({
                                    'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6': true,
                                    'col-start-1 row-start-1 block w-full text-red-400 outline-red-400': _ctx.hasError('email'),
                                }),
                name: "email",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                required: "",
                autocomplete: "email",
                autofocus: ""
              }, null, 2), [
                [_vModelText, _ctx.form.email]
              ]),
              (_ctx.hasError('email'))
                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                    key: 0,
                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.hasError('email'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.getError('email')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('auth_login.password')), 1),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: "/password/reset",
                  class: "font-semibold text-royal-blue-500 hover:text-royal-blue-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('auth_login.forgot_password')), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                id: "password",
                type: "password",
                class: _normalizeClass({
                                    'block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-600 sm:text-sm/6': true,
                                    'col-start-1 row-start-1 block w-full text-red-400 outline-red-400': _ctx.hasError('password'),
                                }),
                name: "password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
                required: "",
                autocomplete: "current-password"
              }, null, 2), [
                [_vModelText, _ctx.form.password]
              ]),
              (_ctx.hasError('password'))
                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                    key: 0,
                    class: "pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4",
                    "aria-hidden": "true"
                  }))
                : _createCommentVNode("", true)
            ]),
            (_ctx.hasError('password'))
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.getError('password')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("button", _hoisted_13, _toDisplayString(_ctx.$t('auth_login.login_button')), 1)
          ])
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _cache[5] || (_cache[5] = _createElementVNode("div", {
            class: "absolute inset-0 flex items-center",
            "aria-hidden": "true"
          }, [
            _createElementVNode("div", { class: "w-full border-t border-gray-200" })
          ], -1)),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('auth_login.or')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("a", {
            href: "#",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.authWith('google')), ["prevent"])),
            class: "flex w-full items-center justify-center gap-3 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus-visible:ring-transparent"
          }, [
            _cache[6] || (_cache[6] = _createStaticVNode("<svg class=\"h-5 w-5\" viewBox=\"0 0 24 24\" aria-hidden=\"true\"><path d=\"M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25527 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z\" fill=\"#EA4335\"></path><path d=\"M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z\" fill=\"#4285F4\"></path><path d=\"M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z\" fill=\"#FBBC05\"></path><path d=\"M12.0004 24.0001C15.2404 24.0001 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2654 14.29L1.27539 17.385C3.25539 21.31 7.3104 24.0001 12.0004 24.0001Z\" fill=\"#34A853\"></path></svg>", 1)),
            _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('auth_login.login_with_google')), 1)
          ])
        ])
      ])
    ])
  ]))
}